<template>
  <div>
    <div v-if="!campaign" class="col-lg-12">
      <loader message="Loading your campaign" />
    </div>
    <div v-if="campaign">
      <campaign-detail
        :id="parseInt(campaign.id, 10)"
        :campaign="campaign"
        :interactions="interactions"
        :loadingCampaignReport="loadingCampaignReport"
        :campaignReportData="campaignReportData"
        :icons="icons"
        :channelTypes="channelTypes"
        :replyMessage="replyMessage"
        @onDownloadMessage="onDownloadMessage($event)"
        @onRandomSelector="onRandomSelector($event)"
      >
      </campaign-detail>
    </div>
    <thread-dialog />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import gql from 'graphql-tag';

import CampaignDetail from '@/components/campaign/CampaignDetail';
import Loader from '@/components/common/Loader';
import ThreadDialog from '@/components/interaction/ThreadDialog';

import * as types from '@/store/modules/interaction/mutation-types';

export default {
  name: 'CampaignDetailContainer',
  components: {
    CampaignDetail,
    Loader,
    ThreadDialog,
  },
  apollo: {
    $client: 'apiv2',
    $subscribe: {
      onInteraction: {
        query: gql`
          subscription {
            onInteraction {
              id
              campaignId
              channelId
              companyId
              threadId
              dateCreated
              dateUpdated
              direction
              flagBlacklisted
              flagComment
              flagFavourite
              flagFraud
              flagSafe
              flagUnsafe
              flagWinner
              ore
              tags
              type
              inCount
              outCount
            }
          }
        `,
        result(response) {
          this.$store.commit(
            `interaction/${types.NEW_INTERACTION_RECEIVED}`,
            response.data.onInteraction,
          );
        },
      },
    },
  },
  data: () => ({
    id: null,
    campaign: null,
  }),

  mounted() {
    this.id = this.$route.params.id;
    this.$store.dispatch('campaign/getCampaignDetail', this.id);
    this.$store.dispatch('analytics/getCampaignReport', this.id);
  },

  computed: {
    ...mapState(['icons', 'channelTypes']),
    ...mapState('campaign', ['campaignDetail', 'replyMessages', 'loadingCampaignDetail']),
    ...mapState('interaction', ['interactions']),
    ...mapState('analytics', ['campaignReportData', 'loadingCampaignReport']),

    replyMessage() {
      const message = this.replyMessages.filter(
        replyMessage => replyMessage.campaign === this.campaign.id,
      );
      if (message.length) {
        return `"${message[0].text}"`;
      }
      return 'No reply message set';
    },
  },

  methods: {
    onDownloadMessage(event) {
      const payload = {
        campaign_id: event.campaign_id,
        date_from: event.date_from,
        unique_originators: false,
        file_name: event.file_name,
        date_to: event.date_to,
      };
      this.$store.dispatch('campaign/downloadMessages', payload);
    },

    onRandomSelector(event) {
      this.$store.dispatch('campaign/runRandomSelector', event);
    },
  },

  watch: {
    loadingCampaignDetail(newVal, oldVal) {
      if (newVal !== oldVal && this.campaignDetail[this.id]) {
        this.campaign = this.campaignDetail[this.id];
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// CampaignDetailContainer.vue?6715bb44